var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PreRenderService } from './pre-render.service';
import { MetaTagService } from './meta-tag.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ListingCategory, ListingType, ListingTypeMap, SortBy } from '../classes/enums';
import { Listing } from '../classes/listing';
import { PositionInfo } from '../classes/user-preferences';
import { HasSubscriptions } from '../components/has-subscriptions';
import { CacheService } from '../services/cache.service';
import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { PreferencesService } from './preferences.service';
import { CommunicationService } from './communication.service';
import { TranslateService } from '@ngx-translate/core';
import { DetailStub } from '../components/listing-details/detail-section/detail-section.component';
import includes from 'lodash-es/includes';
import { CurrencyPipe } from '@angular/common';
import { DatePipe } from '@angular/common';
import { ApiConfigService } from './api-config/api-config.service';
import { environment } from '../../environments/environment-wrapper';
import { ApiService } from './api.service';
import { Helper } from '../classes/helper';
import { exteriorFeaturesFeatureGroups, homeFeaturesFeatureGroups, interiorFeaturesFeatureGroups, neighbourhoodFeaturesFeatureGroups, propertyDetailsFeatureGroups, roomDetailsFeatureGroups, utilitiesFeatureGroups } from '../classes/residential-expanded-detail-sections';
export var MAX_LISTINGS_RETURNED = 10000;
var ListingsService = /** @class */ (function (_super) {
    __extends(ListingsService, _super);
    function ListingsService(appConfig, prerenderService, http, preferencesService, communicationService, translate, cache, currencyPipe, datePipe, apiConfigService, metaTagService, _api) {
        var _this = _super.call(this) || this;
        _this.appConfig = appConfig;
        _this.prerenderService = prerenderService;
        _this.http = http;
        _this.preferencesService = preferencesService;
        _this.communicationService = communicationService;
        _this.translate = translate;
        _this.cache = cache;
        _this.currencyPipe = currencyPipe;
        _this.datePipe = datePipe;
        _this.apiConfigService = apiConfigService;
        _this.metaTagService = metaTagService;
        _this._api = _api;
        _this._favouriteListings = [];
        _this.usedFeatureGroups = [];
        _this._environment = environment;
        _this.addSub(_this.preferencesService.filtersChanged.subscribe(function (filters) { return _this._filters = filters; }));
        _this.addSub(_this.preferencesService.positionInfoChanged.subscribe(function (positionInfo) { return _this._positionInfo = positionInfo; }));
        _this.addSub(_this.preferencesService.favouriteListingsChanged.subscribe(function (favourites) { return _this._favouriteListings = favourites; }));
        _this.addSub(_this.communicationService.listings.currentShownListingType.subscribe(function (s) { return _this._listingCategory = s; }));
        return _this;
    }
    ListingsService.prototype.getBaseUrl = function (route) {
        return this.apiConfigService.getServerRoot(route);
    };
    /**
     * Gets the number of total actives listings in ElasticSearch
     * @param onlyResidential True to exclude commercial
     * @param province optional. Two-letter province code.
     * @param city optional. city name.
     * @param propType optional. Specific Prop Types we want to search for
     */
    ListingsService.prototype.getListingsCount = function (onlyResidential, province, city, propType, onlyOpenHouses, onlyVirtualOpenHouses) {
        var _this = this;
        if (onlyResidential === void 0) { onlyResidential = true; }
        if (province === void 0) { province = null; }
        if (city === void 0) { city = null; }
        if (propType === void 0) { propType = null; }
        var params = new HttpParams();
        var base = this.getBaseUrl(this.appConfig.urls.listings.count);
        var route = this.appConfig.urls.listings.count;
        if (province)
            route += "/" + province;
        if (province && city)
            route += "/" + city.replace(/ /g, '-');
        if (propType) {
            var listingTypeList = ListingTypeMap[propType];
            if (listingTypeList && listingTypeList.length > 0) {
                for (var _i = 0, listingTypeList_1 = listingTypeList; _i < listingTypeList_1.length; _i++) {
                    var id = listingTypeList_1[_i];
                    params = params.append('features.listingTypeIds', id);
                }
            }
        }
        else if (onlyResidential) {
            params = this._excludeCommercialListings(params);
        }
        if (onlyOpenHouses) {
            params = params.append('features.hasOpenHouse', 'true');
        }
        if (onlyVirtualOpenHouses) {
            params = params.append('features.hasVirtualOpenHouse', 'true');
        }
        var hashKey = this.cache.getRequestHash(route, params);
        var hashValue = this.cache.get(hashKey, true);
        if (hashValue) {
            return of(hashValue);
        }
        return this.http.get(base + route, { params: params, withCredentials: true }).pipe(map(function (res) { return res.result; }), tap(function (res) { return _this.cache.set(hashKey, res, 300, true); }));
    };
    /**
     * Search for listings in a city, province, or in the whole country. To be used for province/city homepages.
     * @param province Optional. Two-letter province code
     * @param city Optional. City name
     * @param pagination
     * @param filters
     */
    ListingsService.prototype.searchProvinceCity = function (province, city, pagination, filters, sortBy, isSuggestedListing) {
        var _this = this;
        if (province === void 0) { province = null; }
        if (city === void 0) { city = null; }
        if (filters === void 0) { filters = null; }
        var base = this.getBaseUrl(this.appConfig.urls.listings.provinceCity);
        var route = this.appConfig.urls.listings.provinceCity;
        if (province)
            route += "/" + province;
        if (province && city)
            route += "/" + city;
        var params = this._setSearchParams(pagination, true, sortBy);
        if (filters && filters.featuredListings)
            params = params.append('featuredListings', filters.featuredListings);
        var hashKey = this.cache.getRequestHash(route, params);
        var hashValue = this.cache.get(hashKey);
        if (hashValue) {
            hashValue.results = hashValue.results.map(function (listing) { return new Listing(listing, _this._favouriteListings, isSuggestedListing); });
            return of(hashValue);
        }
        return this.http.get(base + route, { params: params, withCredentials: true }).pipe(map(function (res) {
            res.result.results = res.result.results ? res.result.results.map(function (r) { return new Listing(r, _this._favouriteListings, isSuggestedListing); }) : [];
            return res.result;
        }), tap(function (res) { return _this.cache.set(hashKey, res, 300); }));
    };
    /**
     * Used for searching in the gallery and getting listing previews.
     * @param pagination pagination
     *
     * @returns listing array and an optional office object which is the related Re/Max office to the listings
     */
    ListingsService.prototype.searchListingsGallery = function (pagination, sortBy, includeOffice, overrideBounds) {
        if (includeOffice === void 0) { includeOffice = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var base, route, params, hashKey, hashValue, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = this.getBaseUrl(this.appConfig.urls.listings.gallery);
                        route = this.appConfig.urls.listings.gallery;
                        params = this._setSearchParams(pagination, true, sortBy);
                        params = params.append('includeOffice', includeOffice.toString());
                        if (overrideBounds)
                            params = this._setBoundingBoxParams(params, overrideBounds);
                        hashKey = this.cache.getRequestHash(route, params);
                        hashValue = this.cache.get(hashKey);
                        if (hashValue) {
                            hashValue.results = hashValue.results.map(function (listing) { return new Listing(listing, _this._favouriteListings); });
                            return [2 /*return*/, new Promise(function (resolve) {
                                    resolve(hashValue);
                                })];
                        }
                        return [4 /*yield*/, this.http.get(base + route, { params: params, withCredentials: true })
                                .pipe(map(function (res) {
                                res.result.results = res.result.results ? res.result.results.map(function (r) { return new Listing(r, _this._favouriteListings); }) : [];
                                _this.cache.set(hashKey, res.result, 300);
                                return res.result;
                            }))
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Used for searching in the listings site map.
     * @param listingCategory
     * @param listingPurchaseType
     * @param pagination pagination
     * @returns listing array
     */
    ListingsService.prototype.searchListingsSitemap = function (listingCategory, listingPurchaseType, pagination) {
        var _this = this;
        var base = this.getBaseUrl(this.appConfig.urls.listings.sitemap);
        var route = this.appConfig.urls.listings.sitemap;
        var params = new HttpParams().set('from', (pagination.offset).toString());
        listingCategory.forEach(function (category) {
            params = params.append('features.listingCategoryTypes', category.toString());
        });
        params = params.append('features.listingPurchaseType', listingPurchaseType.toString());
        var hashKey = this.cache.getRequestHash(route, params);
        var hashValue = this.cache.get(hashKey);
        if (hashValue) {
            return of(hashValue);
        }
        return this.http.get(base + route, { params: params, withCredentials: true }).pipe(map(function (res) { return Object.assign(res.result); }), tap(function (res) { return _this.cache.set(hashKey, res, 300); }));
    };
    ListingsService.prototype._setBoundingBoxParams = function (params, bounds) {
        // Deal with the case where we're searching for listings but there's no map available yet so no position info is set
        // Ex: When we're searching by MLS ID on the landing page
        if (bounds.north && bounds.east && bounds.south && bounds.west) {
            return params
                .set('north', '' + bounds.north)
                .set('east', '' + bounds.east)
                .set('south', '' + bounds.south)
                .set('west', '' + bounds.west);
        }
        return params;
    };
    ListingsService.prototype.getFilters = function () {
        var base = this.getBaseUrl(this.appConfig.urls.listings.filters);
        var route = this.appConfig.urls.listings.filters;
        return this.http.get(base + route, { withCredentials: false }).pipe(map(function (res) { return res.result.businessTypes; })).toPromise();
    };
    /**
     * Used for searching on the map and getting listing cluster data.
     * @param zoom Pass in the zoom level directly from the map so we don't get mixed up trying to pull it from preferences and get something outdated
     * @param isPhysicalLocationSearch true if searching based on the user's location, the search will zoom out until it finds a listing
     * @param includeSortFields true to include price and listing date in the result object, to be used in client side sorting
     * @param overrideBounds bounds to override the search bounds for the request
     */
    ListingsService.prototype.searchListingsMap = function (zoom, isPhysicalLocationSearch, includeSortFields, overrideBounds) {
        var _this = this;
        if (includeSortFields === void 0) { includeSortFields = false; }
        var base = this.getBaseUrl(this.appConfig.urls.listings.active);
        var route = this.appConfig.urls.listings.active;
        var positionOfSearch = PositionInfo.clone(this._positionInfo);
        var filterHash = this.cache.getFiltersHash(this._filters);
        var params = this._setSearchParams(null, false)
            .set('isPhysicalLocationSearch', isPhysicalLocationSearch.toString())
            .set('includeSortFields', includeSortFields.toString())
            .set('zoom', zoom.toString());
        if (overrideBounds)
            params = this._setBoundingBoxParams(params, overrideBounds);
        var hashKey = this.cache.getRequestHash(route, params);
        var hashValue = this.cache.get(hashKey);
        if (hashValue) {
            return of(hashValue);
        }
        return this.http.get(base + route, { params: params, withCredentials: true }).pipe(map(function (res) { return Object.assign(res.result, { position: positionOfSearch, filterHash: filterHash }); }), tap(function (res) { return _this.cache.set(hashKey, res, 300); }));
    };
    /**
     * Search for listings based on a string value
     * Called when using the search bar to do a text search for listing previews.
     * @param text search text
     * @param pagination pagination
     */
    ListingsService.prototype.searchListings = function (text, pagination) {
        var _this = this;
        var base = this.getBaseUrl(this.appConfig.urls.listings.search);
        var route = this.appConfig.urls.listings.search;
        var params = this._setSearchParams(pagination, true);
        params = params.append('text', text);
        var hashKey = this.cache.getRequestHash(route, params);
        var hashValue = this.cache.get(hashKey);
        if (hashValue) {
            hashValue.results.forEach(function (listing) { return listing = new Listing(listing, _this._favouriteListings); });
            return of(hashValue);
        }
        return this.http.get(base + route, { params: params, withCredentials: true })
            .pipe(map(function (res) {
            res.result.results = res.result.results ? res.result.results.map(function (r) { return new Listing(r, _this._favouriteListings); }) : [];
            return res.result;
        }))
            .pipe(tap(function (res) { return _this.cache.set(hashKey, res, 300); }));
    };
    /**
     * Search for off market listings based on a string value
     * Called when using the search bar to do a text search for off market listing previews.
     * @param text search text
     */
    ListingsService.prototype.searchOffMarketListings = function (text) {
        var _this = this;
        var base = this.getBaseUrl(this.appConfig.urls.listings.offmarket);
        var route = this.appConfig.urls.listings.offmarket;
        var params = new HttpParams().set('text', text);
        params = params.append('size', '8');
        var hashKey = this.cache.getRequestHash(route, params);
        var hashValue = this.cache.get(hashKey);
        if (hashValue) {
            return of(hashValue);
        }
        return this.http.get(base + route, { params: params, withCredentials: true })
            .pipe(map(function (res) {
            res.result.results = res.result.results ? res.result.results : [];
            return res.result;
        }))
            .pipe(tap(function (res) { return _this.cache.set(hashKey, res, 300); }));
    };
    /**
     * Used to get the preview data for a list of passed in listingIds.
     *
     * @param listingIds A comma separated list of listingIds
     * @param includeOffice True if a related office should be returned in the search
     *
     * @returns listing array and an optional office object which is the related Re/Max office to the listings
     */
    ListingsService.prototype.getListingsPreview = function (listingIds, includeOffice, listingBounds) {
        if (includeOffice === void 0) { includeOffice = false; }
        if (listingBounds === void 0) { listingBounds = null; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var base, route, params, hashKey, hashValue, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = this.getBaseUrl(this.appConfig.urls.listings.preview);
                        route = this.appConfig.urls.listings.preview + listingIds;
                        params = new HttpParams()
                            .set('includeOffice', includeOffice.toString());
                        if (listingBounds && listingBounds.north && listingBounds.east && listingBounds.south && listingBounds.west)
                            params = this._setBoundingBoxParams(params, listingBounds);
                        hashKey = this.cache.getRequestHash(route);
                        hashValue = this.cache.get(hashKey);
                        if (hashValue) {
                            // Double check the hashValue for favourites since these could be changed after it was saved in cache
                            hashValue.results = hashValue.results.map(function (listing) { return new Listing(listing, _this._favouriteListings); });
                            return [2 /*return*/, new Promise(function (resolve) {
                                    resolve(hashValue);
                                })];
                        }
                        return [4 /*yield*/, this.http.get(base + route, { params: params, withCredentials: true })
                                .pipe(map(function (res) {
                                if (res.result) {
                                    res.result.results = res.result.results ? res.result.results.map(function (r) { return new Listing(r, _this._favouriteListings); }) : [];
                                    _this.cache.set(hashKey, res.result, 300);
                                    return res.result;
                                }
                                else {
                                    return { results: [], totalHits: 0 };
                                }
                            }))
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Called from the LDP to get full listing details.
     * @param id listing id
     */
    ListingsService.prototype.getListingDetails = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var base, route, hashKey, hashValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = this.getBaseUrl(this.appConfig.urls.listings.detail);
                        route = this.appConfig.urls.listings.detail + id;
                        hashKey = this.cache.getRequestHash(route);
                        hashValue = this.cache.get(hashKey);
                        if (hashValue) {
                            return [2 /*return*/, new Promise(function (resolve) {
                                    resolve(new Listing(hashValue, _this._favouriteListings, false));
                                })];
                        }
                        return [4 /*yield*/, this.http.get(base + route, { withCredentials: true })
                                .pipe(map(function (res) {
                                _this.cache.set(hashKey, res.result, 300);
                                return new Listing(res.result, _this._favouriteListings, false);
                            }))
                                .toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves listings based on proximity to a center point.
     * Used for getting suggested listings near a point.
     * @param pagination
     * @param filters : Custom Filters object
     * @param centerLatLng : center position to search from
     * @param maxDistance : maximum distance in km to search out fr
     */
    ListingsService.prototype.getListingsByDistanceFrom = function (pagination, filters, centerLatLng, maxDistance, suggestedListing) {
        if (maxDistance === void 0) { maxDistance = 10000; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var base, route, params, hashKey, hashValue, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = this.getBaseUrl(this.appConfig.urls.listings.distance);
                        route = this.appConfig.urls.listings.distance;
                        params = this._setSearchParamsForDistanceSearch(pagination, filters, centerLatLng, maxDistance);
                        hashKey = this.cache.getRequestHash(route, params);
                        hashValue = this.cache.get(hashKey);
                        if (hashValue) {
                            hashValue.results = hashValue.results.map(function (listing) { return new Listing(listing, _this._favouriteListings, suggestedListing); });
                            return [2 /*return*/, new Promise(function (resolve) {
                                    resolve(hashValue);
                                })];
                        }
                        return [4 /*yield*/, this.http.get(base + route, { params: params, withCredentials: true })
                                .pipe(map(function (res) {
                                res.result.results = res.result.results ? res.result.results.map(function (r) { return new Listing(r, _this._favouriteListings, suggestedListing); }) : [];
                                _this.cache.set(hashKey, res.result, 300);
                                return res.result;
                            }))
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ListingsService.prototype._buildPropertyTypes = function (listingTypes) {
        var keys = Object.keys(listingTypes) // [ 'condo', 'house', 'land', ... ]
            .filter(function (k) { return listingTypes[k]; }) // [ 'house', 'land', ... ]
            .map(function (k) { return k === 'commercial' ? ListingType.Commercial : ListingTypeMap[k]; }) // [ [104,160], [102,180], ... ]
            .reduce(function (a, b) { return a.concat(b); }, []); // [ 104, 160, 102, 180 ]
        if (this._listingCategory === ListingCategory.COMMERCIAL) {
            // There's nothing selected, so show all
            if (keys.length === 0)
                keys = ListingTypeMap.commercial;
            else
                keys = keys.filter(function (k) { return ListingTypeMap.commercial.indexOf(k) >= 0; });
        }
        ;
        return keys;
    };
    ListingsService.prototype._buildBusinessTypes = function (businessTypes) {
        return Object.keys(businessTypes).filter(function (k) { return businessTypes[k]; });
    };
    // Explicity include or exclude rentals depending on the value of rentalsOnly
    ListingsService.prototype._handleRentalHttpParams = function (params) {
        var featureType = this._filters.rentalsOnly ? 'features.listingTypeIds' : 'features.excludedListingTypeIds';
        params = params.append(featureType, ListingType.Rental.toString());
        params = params.append(featureType, ListingType.Lease.toString());
        return params;
    };
    ListingsService.prototype._setSearchParams = function (pagination, isGalleryListings, sortBy) {
        var params = new HttpParams().set('zoom', this._positionInfo.zoomLevel.toString());
        params = this._setBoundingBoxParams(params, {
            north: this._positionInfo.north,
            east: this._positionInfo.east,
            south: this._positionInfo.south,
            west: this._positionInfo.west
        });
        if (this._filters.businessTypes) {
            var businessTypeList = this._buildBusinessTypes(this._filters.businessTypes);
            businessTypeList.forEach(function (businessType) {
                params = params.append('features.BusinessTypeSet', businessType);
            });
        }
        if (this._filters.statusTypes && this._filters.statusTypes.comingSoon)
            params = params.append('features.comingSoon', this._filters.statusTypes.comingSoon.toString());
        var listingTypeList = this._buildPropertyTypes(this._filters.listingTypes);
        if (!this._filters.rentalsOnly && listingTypeList && listingTypeList.length > 0) {
            for (var _i = 0, listingTypeList_2 = listingTypeList; _i < listingTypeList_2.length; _i++) {
                var id = listingTypeList_2[_i];
                params = params.append('features.listingTypeIds', id);
            }
        }
        else {
            params = this._handleRentalHttpParams(params);
            if (!this._filters.rentalsOnly && this._listingCategory !== ListingCategory.COMMERCIAL) {
                params = this._excludeCommercialListings(params);
            }
        }
        if (this._listingCategory !== ListingCategory.COMMERCIAL && this._filters.hasOpenHouse) {
            params = params.append('features.hasOpenHouse', 'true');
        }
        if (this._listingCategory !== ListingCategory.COMMERCIAL && this._filters.hasVirtualOpenHouse) {
            params = params.append('features.hasVirtualOpenHouse', 'true');
        }
        if (this._filters.stories && this._filters.stories.min)
            params = params.append('features.StoriesMin', this._filters.stories.min.toString());
        if (this._filters.stories && this._filters.stories.max)
            params = params.append('features.StoriesMax', this._filters.stories.max.toString());
        if (this._filters.parking && this._filters.parking.min)
            params = params.append('features.ParkingSpacesMin', this._filters.parking.min.toString());
        if (this._filters.parking && this._filters.parking.max)
            params = params.append('features.ParkingSpacesMax', this._filters.parking.max.toString());
        if (this._filters.units && this._filters.units.min)
            params = params.append('features.UnitsMin', this._filters.units.min.toString());
        if (this._filters.units && this._filters.units.max)
            params = params.append('features.UnitsMax', this._filters.units.max.toString());
        if (this._filters.totalAcres && this._filters.totalAcres.min)
            params = params.append('features.TotalAcresMin', this._filters.totalAcres.min.toString());
        if (this._filters.totalAcres && this._filters.totalAcres.max)
            params = params.append('features.TotalAcresMax', this._filters.totalAcres.max.toString());
        if (this._filters.sqft && this._filters.sqft.min)
            params = params.append('features.LotSizeMin', this._filters.sqft.min.toString());
        if (this._filters.sqft && this._filters.sqft.max)
            params = params.append('features.LotSizeMax', this._filters.sqft.max.toString());
        if (this._filters.price && this._filters.price.min)
            params = params.append('features.PriceListMin', this._filters.price.min.toString());
        if (this._filters.price && this._filters.price.max)
            params = params.append('features.PriceListMax', this._filters.price.max.toString());
        if (this._filters.pricePerSqFt && this._filters.pricePerSqFt.min)
            params = params.append('features.PricePerSqFtMin', this._filters.pricePerSqFt.min.toString());
        if (this._filters.pricePerSqFt && this._filters.pricePerSqFt.max)
            params = params.append('features.PricePerSqFtMax', this._filters.pricePerSqFt.max.toString());
        if (this._filters.size && this._filters.size.min)
            params = params.append('features.SqFtMin', this._filters.size.min.toString());
        if (this._filters.size && this._filters.size.max)
            params = params.append('features.SqFtMax', this._filters.size.max.toString());
        if (this._filters.beds && this._filters.beds.min)
            params = params.append('features.BedsMin', this._filters.beds.min.toString());
        if (this._filters.beds && this._filters.beds.max)
            params = params.append('features.BedsMax', this._filters.beds.max.toString());
        if (this._filters.baths && this._filters.baths.min)
            params = params.append('features.BathsMin', this._filters.baths.min.toString());
        if (this._filters.baths && this._filters.baths.max)
            params = params.append('features.BathsMax', this._filters.baths.max.toString());
        if (this._filters.updatedSince)
            params = params.append('features.UpdatedSince', this._filters.updatedSince.toString());
        if (this._listingCategory === ListingCategory.COMMERCIAL) {
            params = params.append('features.commercialOnly', '' + true);
        }
        if (this._listingCategory === ListingCategory.LUXURY) {
            params = params.append('features.luxuryOnly', '' + true);
        }
        if (pagination) {
            params = params.append('from', (pagination.offset).toString());
            params = params.append('size', pagination.limit.toString());
        }
        if (isGalleryListings) {
            // Default to SortBy.NEWEST
            var sortKey = null;
            var sortDirection = null; // ASC
            switch (sortBy) {
                case SortBy.NEWEST: {
                    sortKey = 'LISTING_DATE';
                    sortDirection = 1;
                    break;
                }
                case SortBy.OLDEST: {
                    sortKey = 'LISTING_DATE';
                    sortDirection = 0;
                    break;
                }
                case SortBy.PRICE_HIGH_TO_LOW: {
                    sortKey = 'PRICE';
                    sortDirection = 1;
                    break;
                }
                case SortBy.PRICE_LOW_TO_HIGH: {
                    sortKey = 'PRICE';
                    sortDirection = 0;
                    break;
                }
                default: {
                    sortKey = 'LISTING_DATE';
                    sortDirection = 1;
                    break;
                }
            }
            params = params.append('sortKey', sortKey);
            params = params.append('sortDirection', sortDirection.toString());
        }
        return params;
    };
    ListingsService.prototype._setSearchParamsForDistanceSearch = function (pagination, filters, centerLatLng, maxDistance) {
        var params = new HttpParams();
        if (filters && filters.customListingTypeIds && filters.customListingTypeIds.length) {
            filters.customListingTypeIds.forEach(function (id) {
                if (id) {
                    params = params.append('features.listingTypeIds', '' + id);
                }
            });
        }
        else if (this._listingCategory !== ListingCategory.COMMERCIAL) {
            params = this._excludeCommercialListings(params);
        }
        params = params.append('distance.centrelat', '' + centerLatLng.lat);
        params = params.append('distance.centrelon', '' + centerLatLng.lng);
        params = params.append('distance.maxdistanceinmetre', '' + maxDistance);
        params = params.append('distance.sortbyproximity', 'asc'); // Sorts by the closest listings first.
        if (filters.price && filters.price.min)
            params = params.append('features.PriceListMin', filters.price.min.toString());
        if (filters.price && filters.price.max)
            params = params.append('features.PriceListMax', filters.price.max.toString());
        if (filters.pricePerSqFt && filters.pricePerSqFt.min)
            params = params.append('features.PricePerSqFtMin', filters.pricePerSqFt.min.toString());
        if (filters.pricePerSqFt && filters.pricePerSqFt.max)
            params = params.append('features.PricePerSqFtMax', filters.pricePerSqFt.max.toString());
        if (filters.featuredListings)
            params = params.append('featuredListings', filters.featuredListings);
        if (this._listingCategory === ListingCategory.COMMERCIAL) {
            params = params.append('features.commercialOnly', '' + true);
        }
        if (this._listingCategory === ListingCategory.LUXURY) {
            params = params.append('features.luxuryOnly', '' + true);
        }
        params = params.append('from', pagination.offset.toString());
        params = params.append('size', pagination.limit.toString());
        return params;
    };
    ListingsService.prototype._excludeCommercialListings = function (params) {
        ListingTypeMap.excludeCommercial.forEach(function (listingType) {
            params = params.append('features.excludedListingTypeIds', listingType.toString());
        });
        return params;
    };
    ListingsService.prototype.trackPageView = function (pageView) {
        // Make post request to presentation layer
        return this.http.post(this.getBaseUrl(this.appConfig.urls.listings.addPageView) + this.appConfig.urls.listings.addPageView, pageView).toPromise();
    };
    ListingsService.prototype.getClientIPAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('https://jsonip.com').toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ListingsService.prototype.getPriceOrPricePerSqFtString = function (listing) {
        var _this = this;
        // MBL-2059: Only display PricePerSqFt if ListPrice is not provided
        return listing.isCommercial && listing.pricePerSqFt && !listing.listPrice ?
            this.translate.get('listing-summary.per-sqft').pipe(map(function (str) { return _this.currencyPipe.transform(listing.pricePerSqFt, 'CAD', 'symbol-narrow', '1.2-2') + str; })) :
            of(this.currencyPipe.transform(listing.listPrice, 'CAD', 'symbol-narrow', '1.0-0'));
    };
    ListingsService.prototype.getTaxFieldValue = function (listing) {
        var taxYear = listing.taxYear ? ' (' + listing.taxYear + ')' : '';
        return listing.taxAmount ? this.currencyPipe.transform(listing.taxAmount, 'CAD', 'symbol-narrow', '1.0-0') + taxYear : null;
    };
    ListingsService.prototype.setPropertyTaxDetailRow = function (listing, na) {
        if (ListingType.Rental === listing.listingTypeId)
            return;
        var taxDetailStub = new DetailStub({ default: na, title: 'details.property-tax', value: this.getTaxFieldValue(listing) });
        listing.highLevelDetailRows.push(taxDetailStub);
        listing.residentialExpandedDetailSections.propertyDetails.push(taxDetailStub);
    };
    ListingsService.prototype.setFeeDetailRow = function (listing, na) {
        var feesApplicable = includes([].concat(ListingTypeMap.commercial, ListingTypeMap.condo, ListingType.MultiFamily), listing.listingTypeId);
        if (!feesApplicable)
            return;
        var feesDetailStub = new DetailStub({ default: na, title: 'details.fees', value: listing.condoFeesMain ? '$' + listing.condoFeesMain : null });
        listing.highLevelDetailRows.push(feesDetailStub);
    };
    ListingsService.prototype.setLastUpdatedDateDetailRow = function (listing, na) {
        var lastUpdatedDateDetailStub = new DetailStub({ default: na, title: 'details.last-updated', value: this.datePipe.transform(listing.lastUpdated, 'E, LLLL dd, yyyy') });
        listing.highLevelDetailRows.push(lastUpdatedDateDetailStub);
        listing.residentialExpandedDetailSections.propertyDetails.push(lastUpdatedDateDetailStub);
    };
    ListingsService.prototype.setPropertyTypeDetailRow = function (listing, na) {
        var propertyTypeDetailStub = new DetailStub({ default: na, title: 'details.property-type', value: listing.listingTypeId ? this.translate.instant('listingType.' + listing.listingTypeId) : '' });
        listing.highLevelDetailRows.push(propertyTypeDetailStub);
        listing.residentialExpandedDetailSections.homeFeatures.push(propertyTypeDetailStub);
    };
    ListingsService.prototype.setHighLevelDetailRows = function (listing, na) {
        listing.highLevelDetailRows = [];
        this.setPropertyTypeDetailRow(listing, na);
        this.setPropertyTaxDetailRow(listing, na);
        this.setFeeDetailRow(listing, na);
        this.setLastUpdatedDateDetailRow(listing, na);
        var highLevelDetailFeatureGroup = ['Business Type', 'Commercial Type', 'Community', 'Complex', 'Condo Management', 'Condo Name', 'Current Use', 'Disclosures/Documents', 'Documents On File', 'Dues Frequency', 'Electric (amps)', 'Electric (volts)', 'Electric Paid By', 'Escape Clause', 'Exclusions', 'Farm', 'Farm Type', 'Fee Frequency', 'Fee Includes', 'Financing', 'For Sale or Lease', 'FP Fuel', 'Franchise', 'Grade Level Entry Y/N', 'HOA Includes', 'HOA Pay Schedule', 'HOA Terms', 'Income Property', 'Insurance Paid By', 'Lease Includes', 'Location', 'Maintenance Paid By', 'Management', 'Mobile Home Type', 'Nearest Town', 'Occupied By', 'Percolation Test', 'Possession', 'Present Use', 'Price Type', 'Property Sub Type', 'Property Subtype', 'Property Type Detail', 'Quarter', 'Range', 'Recreation', 'Rental Type', 'Residence', 'Restrictions', 'Restrictions/Covenants', 'Sale Rent', 'Sale Terms', 'Sale Type', 'SaleOrRent', 'Showing Instructions', 'Soil Test', 'Sub Property Type', 'Sub Type', 'Survey Available', 'Taxes Paid By', 'Terms', 'Title'];
        this._addFeatureGroupsToSection(listing, listing.highLevelDetailRows, highLevelDetailFeatureGroup);
    };
    ListingsService.prototype.setUtilityDetailRows = function (listing) {
        var utilityDetailStub = [
            new DetailStub({ title: 'details.sewer', value: listing.sewer }),
            new DetailStub({ title: 'details.other', value: listing.services })
        ];
        listing.residentialExpandedDetailSections.utilities = [].concat(utilityDetailStub);
    };
    ListingsService.prototype.setMLSNumDetailRow = function (listing, na) {
        var mlsDetailStub = new DetailStub({ default: na, title: 'details.mls-num', value: listing.mlsNum });
        listing.keyFactRows.push(mlsDetailStub);
        listing.residentialExpandedDetailSections.propertyDetails.push(mlsDetailStub);
    };
    ListingsService.prototype.setDateListedDetailRow = function (listing, na) {
        var dateListedDetailStub = new DetailStub({ default: na, title: 'details.listing-date', value: this.datePipe.transform(listing.listingDate, 'MMM dd, yyyy') });
        listing.keyFactRows.push(dateListedDetailStub);
        listing.residentialExpandedDetailSections.propertyDetails.push(dateListedDetailStub);
    };
    ListingsService.prototype.setKeyFactDetailRows = function (listing, na) {
        listing.keyFactRows = [];
        this.setMLSNumDetailRow(listing, na);
        this.setHousingStyleDetailRow(listing);
        this.setOwnershipTypeDetailRow(listing, na);
        this.setApproximateAgeDetailRow(listing, na);
        this.setSqftAreaDetailRow(listing, na);
        listing.keyFactRows.push(new DetailStub({ title: 'details.contract-conditions', value: listing.contractConditions }));
        this.setDateListedDetailRow(listing, na);
        this.setLotSizeDetailRow(listing, na);
        this.setOccupancyDetailRow(listing, na);
        listing.keyFactRows.push(new DetailStub({ title: 'details.model-type', value: listing.modelType }));
        listing.keyFactRows.push(new DetailStub({ title: 'details.school-district', value: listing.schoolDistrict }));
        this.setSubdivisionDetailRow(listing);
        this.setAcreageDetailRow(listing);
        this.setCommercialTransactionType(listing);
        var keyFactDetailFeatureGroups = ['Condo Fees Term', 'Condo/Assoc Fees Inc', 'Dwelling Type', 'Lease Terms', 'Lease Type', 'Listing Status', 'Lot Size/Acreage', 'Ownership', 'Sq Ft Range', 'Sqft Source', 'Stories', 'Topography', 'Township', 'Type', 'Year Built Description', 'Zoning', 'Zoning Jurisdiction'];
        this._addFeatureGroupsToSection(listing, listing.keyFactRows, keyFactDetailFeatureGroups);
    };
    ListingsService.prototype.setSubdivisionDetailRow = function (listing) {
        var subdivisionDetailStub = new DetailStub({ title: 'details.subdivision', value: listing.subDivision });
        listing.keyFactRows.push(subdivisionDetailStub);
        listing.residentialExpandedDetailSections.homeFeatures.push(subdivisionDetailStub);
    };
    ListingsService.prototype.setHousingStyleDetailRow = function (listing) {
        var housingStyleDetailStub = new DetailStub({ title: 'details.style', value: listing.style });
        listing.keyFactRows.push(housingStyleDetailStub);
        listing.residentialExpandedDetailSections.homeFeatures.push(housingStyleDetailStub);
    };
    ListingsService.prototype.setOccupancyDetailRow = function (listing, na) {
        var occupancyDetailStub = new DetailStub({ default: na, title: 'details.occupancy', value: listing.occupancy });
        listing.keyFactRows.push(occupancyDetailStub);
        listing.residentialExpandedDetailSections.homeFeatures.push(occupancyDetailStub);
    };
    ListingsService.prototype.setOwnershipTypeDetailRow = function (listing, na) {
        var ownershipTypeDetailStub = new DetailStub({ default: na, title: 'details.ownership-type', value: listing.ownershipType });
        listing.keyFactRows.push(ownershipTypeDetailStub);
        listing.residentialExpandedDetailSections.homeFeatures.push(ownershipTypeDetailStub);
    };
    ListingsService.prototype.setApproximateAgeDetailRow = function (listing, na) {
        var isApproximateAgeApplicable = !includes([].concat(ListingTypeMap.land, ListingType.Rental), listing.listingTypeId);
        if (!isApproximateAgeApplicable)
            return;
        listing.keyFactRows.push(new DetailStub({ default: na, title: 'details.approx-age', value: listing.age }));
    };
    ListingsService.prototype.setLotSizeDetailRow = function (listing, na) {
        var isLotSizeApplicable = !includes([].concat(ListingTypeMap.condo, ListingType.Rental), listing.listingTypeId);
        if (!isLotSizeApplicable)
            return;
        var lotSizeDetailStub = new DetailStub({ default: na, title: 'details.lot-size', value: listing.lotSizeRaw ? listing.lotSizeRaw.toString() : null });
        listing.keyFactRows.push(lotSizeDetailStub);
        listing.residentialExpandedDetailSections.exteriorFeatures.push(lotSizeDetailStub);
    };
    ListingsService.prototype.setCommercialTransactionType = function (listing) {
        var isCommercialTransaction = includes([].concat(ListingTypeMap.commercial, ListingType.Rental, ListingType.Farm), listing.listingTypeId);
        if (!isCommercialTransaction)
            return;
        listing.keyFactRows.push(new DetailStub({ title: 'details.transaction-type', value: listing.transactionType }));
    };
    ListingsService.prototype.setAcreageDetailRow = function (listing) {
        var isAcreageApplicable = includes([].concat(ListingTypeMap.commercial, ListingTypeMap.land), listing.listingTypeId);
        if (!isAcreageApplicable)
            return;
        listing.keyFactRows.push(new DetailStub({ title: 'details.total-acres', value: listing.totalAcres ? listing.totalAcres.toString() : null }));
    };
    ListingsService.prototype.setSqftAreaDetailRow = function (listing, na) {
        var isSquareFootageApplicable = !includes([].concat(ListingTypeMap.land, ListingType.Farm), listing.listingTypeId);
        if (!isSquareFootageApplicable)
            return;
        var squareFootDetailStub = new DetailStub({ default: na, title: 'property-details.sqft', value: this.getSquareFootageValue(listing) });
        listing.keyFactRows.push(squareFootDetailStub);
        listing.residentialExpandedDetailSections.homeFeatures.push(squareFootDetailStub);
    };
    ListingsService.prototype.getSquareFootageValue = function (listing) {
        return listing.sqFtRaw ? this.translate.instant('details.size', { value: listing.sqFtRaw, number: 0 }) : null;
    };
    ListingsService.prototype.setRoomDetailRows = function (listing) {
        var roomDetailsStub = [
            new DetailStub({ title: 'details.bedroom', value: listing.bed1Dim }),
            new DetailStub({ title: 'details.bedroom', value: listing.bed2Dim }),
            new DetailStub({ title: 'details.bedroom', value: listing.bed3Dim }),
            new DetailStub({ title: 'details.bedroom', value: listing.bed4Dim }),
            new DetailStub({ title: 'details.bedroom', value: listing.bed5Dim }),
            new DetailStub({ title: 'details.den', value: listing.denDim }),
            new DetailStub({ title: 'details.dining-room', value: listing.diningRoomDim }),
            new DetailStub({ title: 'details.living-room', value: listing.livingRoomDim }),
            new DetailStub({ title: 'details.kitchen', value: listing.kitchenDim }),
            new DetailStub({ title: 'details.master-bedroom', value: listing.masterBedDim }),
            new DetailStub({ title: 'details.family-room', value: listing.familyRoomDim }),
            new DetailStub({ title: 'details.laundry-room', value: listing.laundryDim }),
            new DetailStub({ title: 'details.formal-dining', value: listing.formalDiningAreaDim }),
            new DetailStub({ title: 'details.great-room', value: listing.greatRoomDim }),
            new DetailStub({ title: 'details.other', value: listing.otherRoom1Dim }),
            new DetailStub({ title: 'details.other', value: listing.otherRoom2Dim }),
            new DetailStub({ title: 'details.office-den', value: listing.officeDenDim }),
            new DetailStub({ title: 'details.utility-room', value: listing.utilityDim }),
            new DetailStub({ title: 'details.game-room', value: listing.gameRoomDim }),
            new DetailStub({ title: 'details.media-room', value: listing.mediaRoomDim }),
            new DetailStub({ title: 'details.foyer', value: listing.foyerDim }),
            new DetailStub({ title: 'details.bonus-room', value: listing.bonusDim }),
            new DetailStub({ title: 'details.master-bath', value: listing.masterBath }),
            new DetailStub({ title: 'details.bath', value: listing.bath2 }),
            new DetailStub({ title: 'details.breakfast', value: listing.breakfastDim }),
            new DetailStub({ title: 'details.partial-bathroom', value: listing.partialBathrooms })
        ];
        listing.roomDetailRows = roomDetailsStub;
        listing.residentialExpandedDetailSections.roomDetails = listing.residentialExpandedDetailSections.roomDetails.concat(roomDetailsStub);
    };
    ListingsService.prototype.setInteriorFeatureDetailRows = function (listing, na) {
        listing.insideRows = [];
        this.setHeatingDetailRow(listing, na);
        this.setHeatingSourceDetailRow(listing, na);
        this._addFeatureGroupsToSection(listing, listing.insideRows, ['Heating Fuel', 'Heating/Cooling']);
        this.setBathroomDetailRows(listing);
        listing.insideRows.push(new DetailStub({ title: 'details.pet-policy', value: listing.petPolicy }));
        listing.insideRows.push(new DetailStub({ default: na, title: 'details.rooms', value: listing.rooms ? '' + listing.rooms : null }));
        listing.insideRows.push(new DetailStub({ title: 'details.stories', value: listing.stories ? '' + listing.stories : null }));
        if ('Air Conditioning' in listing.features) {
            this._addFeatureGroupToSection(listing, listing.insideRows, 'Air Conditioning');
        }
        else {
            listing.insideRows.push(new DetailStub({ title: 'details.air-conditioning', value: (typeof listing.airConditioning !== 'undefined') ? listing.airConditioning ? 'Yes' : null : null }));
        }
        this.setCoolingDetailRow(listing);
        this.setFireplaceDetailRow(listing);
        listing.insideRows.push(new DetailStub({ title: 'details.fireplaces', value: listing.fireplaces ? '' + listing.fireplaces : null }));
        if ('HVAC' in listing.features) {
            listing.insideRows.push(new DetailStub({ title: 'details.hvac', value: listing.features['HVAC'].join(', ') }));
        }
        this._addFeatureGroupsToSection(listing, listing.insideRows, ['Fireplace Description', 'Fireplace Fuel', 'Fireplace Location', 'Fireplace Type', 'Fireplace Y/N']);
        this.setBasementDetailRow(listing);
        if (includes([].concat(ListingTypeMap.house, ListingType.Rental), listing.listingTypeId))
            listing.insideRows.push(new DetailStub({ title: 'details.finished-basement', value: listing.basementFinished }));
        this._addFeatureGroupsToSection(listing, listing.insideRows, ['Basement Description', 'Basement Details', 'Basement Development', 'Basement Type', 'Basement Walls']);
        listing.insideRows.push(new DetailStub({ title: 'details.master-bedroom-first-floor', value: (typeof listing.masterBedroomFirstFloor !== 'undefined') ? listing.masterBedroomFirstFloor ? 'Yes' : null : null }));
        this._addFeatureGroupsToSection(listing, listing.insideRows, ['Appliances', 'Electric', 'Electric Available', 'Ensuite', 'Family Room Level', 'Floor Location', 'Flooring', 'Fuel', 'Fuel Type', 'Furnace', 'Furnished', 'Gas', 'Gas Available', 'Hot Water', 'Interior', 'Interior Features', 'Interior Layout', 'Interior Maintenance/Repairs Paid By', 'Laundry', 'Laundry Description', 'Laundry Location', 'Natural Gas', 'Number Of Fireplaces', 'Plumbing', 'Power', 'Power Source', 'Smoke Detector(s)']);
    };
    ListingsService.prototype.setBasementDetailRow = function (listing) {
        var isBasementApplicable = includes([].concat(ListingTypeMap.house), listing.listingTypeId);
        if (!isBasementApplicable)
            return;
        var basementDetailStub = new DetailStub({ title: 'details.basement', value: listing.basement });
        listing.insideRows.push(basementDetailStub);
        listing.residentialExpandedDetailSections.interiorFeatures.push(basementDetailStub);
    };
    ListingsService.prototype.setFireplaceDetailRow = function (listing) {
        if ('Fireplace' in listing.features) {
            this._addFeatureGroupToSection(listing, listing.insideRows, 'Fireplace');
        }
        else if (listing.fireplace) {
            var fireplaceDetailStub = new DetailStub({ title: 'details.fireplace', value: 'Yes' });
            listing.insideRows.push(fireplaceDetailStub);
            listing.residentialExpandedDetailSections.interiorFeatures.push(fireplaceDetailStub);
        }
    };
    ListingsService.prototype.setCoolingDetailRow = function (listing) {
        if ('Cooling' in listing.features) {
            this._addFeatureGroupToSection(listing, listing.insideRows, 'Cooling');
        }
        else if (listing.cooling) {
            var coolingDetailStub = new DetailStub({ title: 'details.cooling', value: 'Yes' });
            listing.insideRows.push(coolingDetailStub);
            listing.residentialExpandedDetailSections.interiorFeatures.push(coolingDetailStub);
        }
    };
    ListingsService.prototype.setHeatingSourceDetailRow = function (listing, na) {
        var heatingSourceDetailStub = new DetailStub({ default: na, title: 'details.heating-source', value: listing.heatingSource });
        listing.insideRows.push(heatingSourceDetailStub);
        listing.residentialExpandedDetailSections.interiorFeatures.push(heatingSourceDetailStub);
    };
    ListingsService.prototype.setBathroomDetailRows = function (listing) {
        var bathroomDetailStub = [
            new DetailStub({ title: 'details.baths-full', value: listing.fullBaths }),
            new DetailStub({ title: 'details.baths-half', value: listing.halfBaths })
        ];
        listing.insideRows = listing.insideRows.concat(bathroomDetailStub);
        listing.residentialExpandedDetailSections.roomDetails = listing.residentialExpandedDetailSections.roomDetails.concat(bathroomDetailStub);
    };
    ListingsService.prototype.setHeatingDetailRow = function (listing, na) {
        var isHeatingApplicable = !includes(ListingTypeMap.land, listing.listingTypeId);
        if (!isHeatingApplicable)
            return;
        var heatingDetailStub = new DetailStub({ default: na, title: 'details.heating', value: listing.heating });
        listing.insideRows.push(heatingDetailStub);
        listing.residentialExpandedDetailSections.interiorFeatures.push(heatingDetailStub);
    };
    ListingsService.prototype.setExteriorDetailRows = function (listing) {
        listing.outsideRows = [];
        this.exteriorDetailsNotApplicableForCondos(listing);
        if (includes([].concat(ListingTypeMap.house, ListingTypeMap.commercial, ListingType.Rental, ListingTypeMap.condo), listing.listingTypeId))
            listing.outsideRows.push(new DetailStub({ title: 'details.parking-spaces', value: listing.parkingSpaces ? '' + listing.parkingSpaces : null }));
        this._addFeatureGroupsToSection(listing, listing.outsideRows, ['Parking', 'Parking Description', 'Parking Surface', 'Parking Types']);
        if ('Garage' in listing.features) {
            this._addFeatureGroupToSection(listing, listing.outsideRows, 'Garage');
        }
        else {
            listing.outsideRows.push(new DetailStub({ title: 'details.garage', value: (typeof listing.garage !== 'undefined') ? listing.garage ? 'Yes' : null : null }));
        }
        if (!listing.isCondo) {
            listing.outsideRows.push(new DetailStub({ title: 'details.garage-spaces', value: listing.garageSpaces ? '' + listing.garageSpaces : null }));
        }
        if (!listing.isCondo) {
            listing.outsideRows.push(new DetailStub({ title: 'details.garage-type', value: listing.garageType }));
        }
        this._addFeatureGroupsToSection(listing, listing.outsideRows, ['Garage Capacity', 'Garage Description', 'Garage/Carport']);
        listing.outsideRows.push(new DetailStub({ title: 'details.area', value: listing.area }));
        this._addFeatureGroupsToSection(listing, listing.outsideRows, ['Exterior Features', 'Exterior Finish']);
        if ('Pool' in listing.features) {
            this._addFeatureGroupToSection(listing, listing.outsideRows, 'Pool');
        }
        else {
            listing.outsideRows.push(new DetailStub({ title: 'details.pool', value: (typeof listing.pool !== 'undefined') ? listing.pool ? 'Yes' : null : null }));
        }
        this._addFeatureGroupsToSection(listing, listing.outsideRows, ['Pool Features', 'Pool YN']);
        if (!listing.isCondo) {
            listing.outsideRows.push(new DetailStub({ title: 'details.roof', value: listing.roof }));
        }
        this._addFeatureGroupsToSection(listing, listing.outsideRows, ['Roofing', 'Roofing Description']);
        listing.outsideRows.push(new DetailStub({ title: 'details.waterview', value: (typeof listing.waterview !== 'undefined') ? listing.waterview ? 'Yes' : null : null }));
        if ('Waterfront' in listing.features) {
            this._addFeatureGroupToSection(listing, listing.outsideRows, 'Waterfront');
        }
        else {
            listing.outsideRows.push(new DetailStub({ title: 'details.waterfront', value: (typeof listing.waterfront !== 'undefined') ? listing.waterfront ? 'Yes' : null : null }));
        }
        this._addFeatureGroupsToSection(listing, listing.outsideRows, ['Waterfront Features', 'Waterfront YN']);
        this._addFeatureGroupsToSection(listing, listing.outsideRows, ['Access', 'Access Road', 'Building Style', 'Building Type', 'Buildings', 'Bush', 'Carport', 'Construction', 'Construction Type', 'Covered Parking', 'Direction Facing', 'District', 'Exposure', 'Extra Structures', 'Fence', 'Fencing', 'Fronting On', 'Frontage', 'Gated', 'Loading Dock', 'Loading Info', 'Major Area', 'Out Buildings', 'Outdoor Area', 'Patio', 'Present Structures', 'Rear Exposure', 'Road', 'Road Between Waterfront And Home', 'Site Description', 'Site Influence', 'Site Influences', 'Site Information', 'Soil', 'Sprinklers', 'Storm Sewage Drain']);
    };
    ListingsService.prototype.setDrivewayDetailRow = function (listing) {
        var drivewayDetailStub = new DetailStub({ title: 'details.driveway', value: listing.driveway });
        listing.outsideRows.push(drivewayDetailStub);
        listing.residentialExpandedDetailSections.exteriorFeatures.push(drivewayDetailStub);
    };
    ListingsService.prototype.setExteriorFieldDetailRow = function (listing) {
        var exteriorDetailStub = new DetailStub({ title: 'details.exterior', value: listing.exterior });
        listing.outsideRows.push(exteriorDetailStub);
        listing.residentialExpandedDetailSections.exteriorFeatures.push(exteriorDetailStub);
    };
    ListingsService.prototype.setFoundationDetailRow = function (listing) {
        var foundationDetailStub = new DetailStub({ title: 'details.foundation', value: listing.foundation });
        listing.outsideRows.push(foundationDetailStub);
        listing.residentialExpandedDetailSections.exteriorFeatures.push(foundationDetailStub);
    };
    ListingsService.prototype.exteriorDetailsNotApplicableForCondos = function (listing) {
        if (listing.isCondo)
            return;
        this.setAcreageDetailRows(listing);
        this.setFoundationDetailRow(listing);
        this.setExteriorFieldDetailRow(listing);
        this.setDrivewayDetailRow(listing);
    };
    ListingsService.prototype.setAcreageDetailRows = function (listing) {
        listing.outsideRows.push(new DetailStub({ title: 'details.acreage', value: listing.acreage }));
        this._addFeatureGroupToSection(listing, listing.outsideRows, 'Acreage Range');
    };
    ListingsService.prototype.populateListingRowInfo = function (listing) {
        if (!listing)
            return;
        var na = this.translate.instant('na');
        this._removeFeatures(listing);
        this.setHighLevelDetailRows(listing, na);
        this.setKeyFactDetailRows(listing, na);
        this.setRoomDetailRows(listing);
        this.setInteriorFeatureDetailRows(listing, na);
        this.setExteriorDetailRows(listing);
        this.setUtilityDetailRows(listing);
        this.setResidentialFeatureGroups(listing);
        this.setAdditionalDetailRowsFromRemainingFeaturesGroups(listing);
    };
    ListingsService.prototype.setResidentialFeatureGroups = function (listing) {
        // Utilities uses the same object field for all of residential, commercial and luxury
        this._addFeatureGroupsToSection(listing, listing.residentialExpandedDetailSections.utilities, utilitiesFeatureGroups);
        if (!listing.isResidential)
            return;
        this._addFeatureGroupsToSection(listing, listing.residentialExpandedDetailSections.propertyDetails, propertyDetailsFeatureGroups);
        this._addFeatureGroupsToSection(listing, listing.residentialExpandedDetailSections.homeFeatures, homeFeaturesFeatureGroups);
        this._addFeatureGroupsToSection(listing, listing.residentialExpandedDetailSections.roomDetails, roomDetailsFeatureGroups);
        this._addFeatureGroupsToSection(listing, listing.residentialExpandedDetailSections.interiorFeatures, interiorFeaturesFeatureGroups);
        this._addFeatureGroupsToSection(listing, listing.residentialExpandedDetailSections.exteriorFeatures, exteriorFeaturesFeatureGroups);
        this._addFeatureGroupsToSection(listing, listing.residentialExpandedDetailSections.neighbourhoodFeatures, neighbourhoodFeaturesFeatureGroups);
    };
    ListingsService.prototype.setAdditionalDetailRowsFromRemainingFeaturesGroups = function (listing) {
        listing.additionalFeatureRows = [];
        this.clearUsedFeatureGroups(listing);
        if ('BelowGradeFinishedAreaUnits' in listing.features) {
            listing.features['BelowGradeFinishedAreaUnits'] = null;
        }
        if ('AboveGradeFinishedAreaUnits' in listing.features) {
            listing.features['AboveGradeFinishedAreaUnits'] = null;
        }
        if ('BuildingAreaUnits' in listing.features) {
            listing.features['BuildingAreaUnits'] = null;
        }
        this.pushDetailRowsForRemainingFeatureGroups(listing);
    };
    ListingsService.prototype.pushDetailRowsForRemainingFeatureGroups = function (listing) {
        for (var group in listing.features) {
            // All of the feature groups that have already been added were set to null, so just add in any remaining.
            if (listing.features[group] != null) {
                listing.additionalFeatureRows.push(new DetailStub({ title: 'details.' + Helper.replaceWhitespace(group.trim(), '-').toLowerCase(), value: listing.features[group].join(', ') }));
            }
        }
        if (listing.isResidential) {
            listing.residentialExpandedDetailSections.other = listing.additionalFeatureRows;
        }
    };
    ListingsService.prototype.trackUsedFeatureGroups = function (featureGroupKey) {
        this.usedFeatureGroups.push(featureGroupKey);
    };
    /**
     * Set the feature to null so that later on in our catch all remaining code,
     * we only get the features that didn't make it into a group.
     * @param listing
     */
    ListingsService.prototype.clearUsedFeatureGroups = function (listing) {
        for (var _i = 0, _a = this.usedFeatureGroups; _i < _a.length; _i++) {
            var group = _a[_i];
            listing.features[group] = null;
        }
    };
    /**
     * Take in a list of feature groups to add to the row section.
     * @param listing The listing being updated
     * @param rows The section to add the features to
     * @param featureGroups The feature group names
     */
    ListingsService.prototype._addFeatureGroupsToSection = function (listing, rows, featureGroups) {
        for (var _i = 0, featureGroups_1 = featureGroups; _i < featureGroups_1.length; _i++) {
            var group = featureGroups_1[_i];
            this._addFeatureGroupToSection(listing, rows, group);
        }
    };
    ListingsService.prototype._removeFeatures = function (listing) {
        delete listing.features['AssociationYN'];
    };
    /**
     * Take in a single feature group and add it to the row section.
     * @param listing The listing being updated
     * @param rows The section to add the feature to
     * @param group The feature group name
     */
    ListingsService.prototype._addFeatureGroupToSection = function (listing, rows, group) {
        if (group in listing.features) {
            rows.push(new DetailStub({ title: group, value: listing.features[group].join(', ') }));
            this.trackUsedFeatureGroups(group);
        }
    };
    /**
   * Iterates over the listings to determine the highest and lowest price listings and sets the aggregateOfferSchema array with a
   * JSON Object for Schema purposes
   */
    ListingsService.prototype.checkForProductValues = function (data, city, isBusinessOpportunity) {
        var highVal = 0, lowVal = data && data.length > 0 ? data[0].listPrice : 0;
        var boardName = isBusinessOpportunity ? this._setBusinessOpportunityBoardName(city) : this._setResidentialBoardName(city);
        data.forEach(function (p) {
            highVal = p.listPrice > highVal ? p.listPrice : highVal;
            lowVal = p.listPrice < lowVal ? p.listPrice : lowVal;
        });
        // [MBL-2738] - Added new fields (image, description, brand) to product schema
        // Fixed the lowPrice value, so instead of null the lowest will be 0
        return [{
                '@context': 'http://schema.org',
                '@type': 'Product',
                name: boardName,
                brand: 'RE/MAX Canada',
                description: this.metaTagService.getMetaTagAttr('name="description"').content,
                image: this._environment.staticResourceRoot + "assets/BalloonLarge.svg",
                offers: {
                    '@type': 'AggregateOffer',
                    lowPrice: lowVal,
                    highPrice: highVal,
                    priceCurrency: 'CAD',
                },
            }];
    };
    ListingsService.prototype._setResidentialBoardName = function (city) {
        return (city ? city.substr(0, 1).toUpperCase() + city.substr(1, city.length) : 'Canada') + ' Real Estate';
    };
    ListingsService.prototype._setBusinessOpportunityBoardName = function (city) {
        return "Businesses For Sale " + (city ? city.substr(0, 1).toUpperCase() + city.substr(1, city.length) : 'Canada');
    };
    return ListingsService;
}(HasSubscriptions));
export { ListingsService };
